<mat-dialog-content fxLayout="column">
    <div [fxHide]="!loading" fxFlex="1 1 auto" fxLayout="column">
        <div fxFlex="1 1 auto"></div>
        <p-progressSpinner fxFlex="0 0 auto" [style]="{width: '50px', height: '50px'}" class="spinner" animationDuration="2s"></p-progressSpinner>
        <div fxFlex="1 1 auto"></div>
    </div>
    <div [fxHide]="loading" fxFlex="1 1 auto" fxLayout="column">
        <div fxFlex="0 0 auto" fxLayout="row">
            <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
                <span class="liquitics-h5">Today's Transactions by Count</span>
                <div id="todayscountchartdiv" class="chartdiv"></div>
            </div>
            <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
                <span class="liquitics-h5">Today's Transactions by Amount</span>
                <div id="todayssumchartdiv" class="chartdiv"></div>
            </div>
            <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
                <span class="liquitics-h5">Recent Transactions by Count</span>
                <div id="recentcountchartdiv" class="chartdiv"></div>
            </div>
            <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
                <span class="liquitics-h5">Recent Transactions by Amount</span>
                <div id="recentsumchartdiv" class="chartdiv"></div>
            </div>
            <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
                <span class="liquitics-h5">Past Top Transactions by Count</span>
                <div id="topcountchartdiv" class="chartdiv"></div>
            </div>
            <div fxFlex="1 1 auto" fxLayout="column" class="chartwrapper liquitics-box">
                <span class="liquitics-h5">Past Top Transactions by Amount</span>
                <div id="topsumchartdiv" class="chartdiv"></div>
            </div>
        </div>
        <app-transaction-table fxFlex="1 1 calc(100%-200px)" [transactionDetailResult]="transactionDetailResult" [rowsPerPage]=15></app-transaction-table>
    </div>
</mat-dialog-content>